import React from 'react';
import { toast } from 'react-toastify';
import { CheckCircle, Loader2, FileSignature } from 'lucide-react';
import { CustomModal } from '../../../../common/CustomModal';
import { SignaturePad } from '../../../../common/SignaturePad';
import i18n from '../../../../../i18n';
import { startDeliveryApproval } from '../../AuctionApproval/services/auctionApprovalServices';
import '../../../../../styles/components/action-modal.scss';
import '../../../../../styles/components/delivery-approval-modal.scss';

export class DeliveryApprovalModal extends React.Component {
  sigPadRef = React.createRef();

  state = {
    is_loading: false,
    error: '',
  };

  handleClose = () => {
    if (this.state.is_loading) return;
    this.setState({ error: '' });
    this.props.onClose && this.props.onClose();
  };

  handleClearSignature = () => {
    if (this.sigPadRef.current) {
      this.sigPadRef.current.clear();
    }
  };

  handleSubmit = async () => {
    const { auction } = this.props;

    if (!auction || !auction.id) {
      toast.error(i18n.t('something_went_wrong') || 'Something went wrong');
      return;
    }

    const signature = this.sigPadRef.current && this.sigPadRef.current.getSignature();

    if (!signature) {
      this.setState({ error: i18n.t('signature_required') || 'Please provide your signature before submitting.' });
      return;
    }

    this.setState({ is_loading: true, error: '' });

    try {
      const response = await startDeliveryApproval(auction.id, { signature });

      if (response && response.success) {
        toast.success(response.message || i18n.t('success') || 'Delivery approval started successfully.');
        this.props.onSuccess && this.props.onSuccess();
      } else {
        toast.error((response && response.message) || i18n.t('failed') || 'Something went wrong');
      }
    } catch (err) {
      console.error(err);
      toast.error(i18n.t('failed') || 'Something went wrong');
    } finally {
      this.setState({ is_loading: false });
    }
  };

  renderFooter() {
    const { is_loading } = this.state;

    return (
      <div className="header-action">
        <button type="button" className="button1 button1-gray" onClick={this.handleClose} disabled={is_loading}>
          {i18n.t('cancel') || 'Cancel'}
        </button>
        <button type="button" className="button1 button1-primary" onClick={this.handleSubmit} disabled={is_loading}>
          <CheckCircle size={18} />
          {is_loading ? (
            <>
              <Loader2 className="animate-spin" size={16} /> {i18n.t('submitting') || 'Submitting...'}
            </>
          ) : (
            i18n.t('sign_and_send') || 'Sign & Send'
          )}
        </button>
      </div>
    );
  }

  render() {
    const { show, auction } = this.props;
    const { is_loading, error } = this.state;

    return (
      <CustomModal
        isOpen={show}
        onClose={this.handleClose}
        header={i18n.t('delivery_clearance') || 'Delivery Clearance'}
        headerIcon={<FileSignature size={18} />}
        footer={this.renderFooter()}
        modalClassName="delivery-approval-modal"
      >
        <div className="action-modal-container">
          <form className="wam-form-section" autoComplete="off">
            <div className="dam-instructions">
              <FileSignature size={18} />
              <span>
                {i18n.t('operator_signature_instructions') ||
                  'Please sign below to confirm the delivery clearance for this auction. The auction winner will be asked to sign next before delivery can start.'}
              </span>
            </div>

            {auction && (
              <div className="wam-form-group">
                <label className="wam-form-label">{i18n.t('auction') || 'Auction'}</label>
                <div className="wam-static-value">{auction.title || auction.name || `#${auction.id}`}</div>
              </div>
            )}

            <div className="wam-form-group">
              <label className="wam-form-label">
                {i18n.t('operator_signature') || 'Operator Signature'}
                <span className="wam-required-mark">*</span>
              </label>

              <SignaturePad ref={this.sigPadRef} disabled={is_loading} />

              {error && <div className="wam-field-error">{error}</div>}
            </div>
          </form>
        </div>
      </CustomModal>
    );
  }
}